import { Route, Routes } from 'react-router';
import { selectIsSidebarOpen } from '@/store/global/globalSlice';
import { useAppSelector } from '@/store/hooks';
import {
  SIDEBAR_WIDTH,
  SIDEBAR_SMALL_WIDTH,
  MOBILE_WIDTH,
  HEADER_HEIGHT,
} from '@/constants';
import { useWindowSize } from '@data-products-and-ai/react-components';
import {
  NotFoundPage,
  OutagesPage,
  OutagePage,
  MillwrightsPage,
  MillwrightPage,
  OutageTaskPage,
  HomePage,
} from '@/pages';
import {
  OUTAGE_MILLWRIGHT_ROUTE,
  OUTAGE_ROUTE,
  OUTAGES_ROUTE,
} from '@/pages/Outages/routes';
import {
  MILLWRIGHT_ROUTE,
  MILLWRIGHTS_ROUTE,
} from '@/pages/Millwrights/routes';
import { OUTAGE_TASK_ROUTE } from '@/pages/Tasks/routes';
import { HOME_ROUTE } from '@/pages/Home/routes';

import '@/components/MainContent/MainContent.scss';

export const MainContent = () => {
  const { width } = useWindowSize();
  const isMobile = width <= MOBILE_WIDTH;
  const isSidebarOpen = useAppSelector(selectIsSidebarOpen);
  const containerStyles = {
    marginLeft:
      isSidebarOpen && !isMobile ? SIDEBAR_WIDTH : SIDEBAR_SMALL_WIDTH,
    marginTop: HEADER_HEIGHT,
  };

  return (
    <div className="main-content" style={containerStyles}>
      <Routes>
        <Route path="*" element={<NotFoundPage />} />
        <Route path={HOME_ROUTE} element={<HomePage />} />
        <Route path={OUTAGES_ROUTE} element={<OutagesPage />} />
        <Route path={OUTAGE_ROUTE} element={<OutagePage />} />
        <Route path={OUTAGE_TASK_ROUTE} element={<OutageTaskPage />} />
        <Route path={OUTAGE_MILLWRIGHT_ROUTE} element={<MillwrightPage />} />
        <Route path={MILLWRIGHTS_ROUTE} element={<MillwrightsPage />} />
        <Route path={MILLWRIGHT_ROUTE} element={<MillwrightPage />} />
      </Routes>
    </div>
  );
};
